"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFormRow = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledFormRow = _styledComponents.default.div.withConfig({
  displayName: "FormRowstyles__StyledFormRow",
  componentId: "sc-1cux4ua-0"
})(["width:100%;display:flex;flex-direction:column;@media only screen and (min-width:", "){flex-direction:row;}.c-form-row-child{flex:1 1 100%;@media only screen and (min-width:", "){margin:0 ", ";&:first-child{margin-left:0;}&:last-child{margin-right:0;}}}"], function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', '2', props.theme.standardPadding);
});

exports.StyledFormRow = StyledFormRow;